import type { AxiosResponse, Method } from 'lib/axios';
import { APICallV4 } from 'reactApp/api/APICall';
import type { QuotaCleanerGroupParam } from 'reactApp/modules/userQuotaCleaner/userQuotaCleaner.types';
import type { UserQuotaCleanerDelete, UserQuotaCleanerGroup } from 'reactApp/types/QuotaCleaner';

import type { FastCleanInfo, QuotaCleanerListParam, QuotaFastCleanListParam } from './QuotaCleanerAPICall.types';

class QuotaCleanerListAPICall extends APICallV4<{ body?: { groups: UserQuotaCleanerGroup[] } }> {
    _method = 'user/quota/list';
    _type: Method = 'post';
}

class QuotaCleanerGroupAPICall extends APICallV4<{ body?: UserQuotaCleanerGroup }> {
    _method = 'user/quota/group';
    _type: Method = 'post';
}

class QuotaCleanerDeleteAPICall extends APICallV4<{ body?: UserQuotaCleanerDelete }> {
    _method = 'user/quota/delete';
    _type: Method = 'post';
}

class QuotaCleanerFastCleanAPICall extends APICallV4<{ body?: FastCleanInfo }> {
    _method = 'user/quota/easy_clear';
    _type: Method = 'post';
}

export const quotaCleanerListApiCall = (
    groupParams: QuotaCleanerListParam
): Promise<
    AxiosResponse<{
        body?: { groups: UserQuotaCleanerGroup[] };
    }>
> => new QuotaCleanerListAPICall().makeRequest(groupParams);

export const quotaCleanerGroupApiCall = (
    groupParam: QuotaCleanerGroupParam
): Promise<
    AxiosResponse<{
        body?: UserQuotaCleanerGroup;
    }>
> => new QuotaCleanerGroupAPICall().makeRequest(groupParam);

export const quotaCleanerItemsDeleteApiCall = (
    ids: string[],
    file_list: boolean
): Promise<
    AxiosResponse<{
        body?: UserQuotaCleanerDelete;
    }>
> => new QuotaCleanerDeleteAPICall().makeRequest({ ids, file_list });

export const quotaCleanerFastCleanApiCall = (
    groupParams: QuotaFastCleanListParam
): Promise<
    AxiosResponse<{
        body?: FastCleanInfo;
    }>
> => new QuotaCleanerFastCleanAPICall().makeRequest(groupParams);
